import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f1ba49a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduction" }
const _hoisted_2 = {
  key: 0,
  class: "releases"
}
const _hoisted_3 = {
  key: 0,
  class: "releases__title"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "contain-video" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "introduction__video",
    "data-iframe": "",
    src: "https://www.youtube.com/embed/OwIpXBMmRL0",
    title: "YouTube video player",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<p class=\"introduction__description\" data-v-6f1ba49a></p><div class=\"introduction__goals\" data-v-6f1ba49a><div class=\"introduction__goal-detail\" data-v-6f1ba49a><span data-v-6f1ba49a>SENIORIDADE DOS PROFISSIONAIS E AUMENTO DA PRODUTIVIDADE</span></div><div class=\"introduction__goal-detail\" data-v-6f1ba49a><span data-v-6f1ba49a>RETENÇÃO DE TALENTOS</span></div><div class=\"introduction__goal-detail\" data-v-6f1ba49a><span data-v-6f1ba49a>DESENVOLVIMENTO DE LIDERANÇAS</span></div><div class=\"introduction__goal-detail\" data-v-6f1ba49a><span data-v-6f1ba49a>PROMOVER A MENTALIDADE DA INOVAÇÃO</span></div><div class=\"introduction__goal-detail\" data-v-6f1ba49a><span data-v-6f1ba49a>MAIS QUALIDADE NAS ENTREGAS</span></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_section_divisor = _resolveComponent("section-divisor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.newsCourses.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.newsCourses.length)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, "NOVIDADES"))
            : _createCommentVNode("", true),
          _createVNode(_component_Carousel, {
            breakpoints: _ctx.breakpoints,
            settings: _ctx.settings
          }, {
            addons: _withCtx(() => [
              _createVNode(_component_Navigation)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsCourses, (card, index) => {
                return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, {
                      duration: _ctx.formattedDuration(card.duration),
                      rating: card.rating,
                      title: card.title,
                      "thumbnail-u-r-l": card.imageURL,
                      course: card
                    }, null, 8, ["duration", "rating", "title", "thumbnail-u-r-l", "course"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["breakpoints", "settings"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_section_divisor, {
      title: "Sobre nós",
      "color-label": "#fafafa",
      class: "introduction__title",
      "color-line": "#fafafa"
    }),
    _hoisted_4,
    _hoisted_5
  ]))
}